import { useMutation, useQueryClient } from '@tanstack/react-query';

// The marks clear — the panel's seventh WRITE, and the second that acts on a device rather than on a
// `Delivery`. The clear fn is injected (DI, mock-testable). retry: false — a refused clear must
// never be silently re-sent, and the one refusal that matters (the incident already exists) is a
// verdict, not a blip.
//
// Its invalidation set is as narrow as «Confirmar secuencia»'s: the «Entrega» does not change when
// marks are cleared, so `delivery-detail`, `user-deliveries` and `box-status` stay untouched.
// Invalidating the detail would raise the card skeleton and fold the region shut under the agent the
// instant they confirm. The marks go by EXACT key and the box log by prefix, since the clear is
// recorded there.
//
// The error path invalidates NOTHING here: the code-aware refetch lives with the banner it
// accompanies, in the component that owns the flow, so the two cannot drift apart.
export function useClearBoxMarks(boxId: string, clearBoxMarks: (boxId: string) => Promise<void>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => clearBoxMarks(boxId),
    retry: false,
    // Fire-and-forget: do NOT return the promise. Returning it makes TanStack await the refetch
    // before the mutation settles, which would hide the refetch state the caller drives off.
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['box-marks', boxId] });
      void queryClient.invalidateQueries({ queryKey: ['locker-log'] });
    },
  });
}
